import { useDispatch } from 'react-redux';

import { CoreHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { getSavedTokenDataFromStorage } from '@helpers';
import { useLogger } from '@hooks';
import { noFlowPath, subscriptionFlowPathCompany, subscriptionFlowPathIziBizi } from '@navigation';
import { clearUserInput, NavigationState, saveStep, Flow, useNavigationStore, usePTCMetadata } from '@store';

interface NavigationFlow {
	flow: string[];
	type: Flow;
}
interface NavigationStepOutput {
	current: string;
	previous?: string;
	getFlow: (currentStep: string) => NavigationFlow;
	setNavigationStep: (currentStep: string, previousStep?: string) => void;
}
export const useNavigationStep = (): NavigationStepOutput => {
	const dispatch = useDispatch();
	const logger = useLogger();
	const { current, previous, flow } = useNavigationStore();
	let chosenPath: string[] = [];
	// const metadata = usePTCMetadata();
	const state = getSavedTokenDataFromStorage<string>('state');

	if (CoreHelper.isNullOrEmpty(chosenPath)) {
		chosenPath = deliverFlow(state);
	}

	const getFlow = (currentStep: string): NavigationFlow => {
		let flowPath: string[];
		let typeFlow: Flow;
		//Select flow to run

		if (chosenPath.includes(currentStep)) {
			flowPath = chosenPath;
			typeFlow = 'subscription';
		} else {
			flowPath = noFlowPath;
			typeFlow = 'noFlow';
		}

		return { flow: flowPath, type: typeFlow };
	};

	const setNavigationStep = (currentStep: string) => {
		const flowReturned: NavigationFlow = getFlow(currentStep);

		logger('useNavigationStep > setNavigationStep > ', {
			current: currentStep,
			previous: current,
			flowOfCurrentStep: flowReturned.type,
			flowOnStore: flow,
		});

		const data: NavigationState = {
			current: currentStep,
			previous: current,
			flow: flowReturned.type,
		};
		dispatch(saveStep(data));
		if (
			flow !== flowReturned.type &&
			flow !== 'noFlow' &&
			flowReturned.type !== 'noFlow' &&
			(flow === 'integratedSolution' || flow === 'subscription')
		) {
			dispatch(clearUserInput());
		}
	};

	return {
		current,
		previous,
		setNavigationStep,
		getFlow,
	};
};

// returns the flow added, needs BE to return token
function deliverFlow(state: string | undefined) {
	let selectedFlowTest: string[] = [];

	if (CoreHelper.isNullOrEmpty(state)) {
		selectedFlowTest = [...subscriptionFlowPathCompany];
	} else {
		selectedFlowTest = [...subscriptionFlowPathIziBizi];
	}
	// switch (state) {
	// 	case 'ecommerce':
	// 		selectedFlowTest = [...subscriptionFlowPathCompany];
	// 		break;

	// 	case 'iziBizi':
	// 		selectedFlowTest = [...subscriptionFlowPathIziBizi];
	// 		break;

	// 	//For future flows
	// 	case 'B':
	// 		break;
	// }

	return selectedFlowTest;
}
